// import axios from '@/lib/axios';
// import React, { useState } from 'react';
// import { useForm } from 'react-hook-form';
// import { useAuth } from '../../hooks/auth';
// import { toast } from 'react-toastify';

// interface OTPFormInputs {
//   email: string;
//   otp_code?: string;
// }

// const LoginWithOTP = () => {
//   const [otpSent, setOtpSent] = useState(false);
//   const [emailStored, setEmailStored] = useState('');
//   const [loading, setLoading] = useState(false); // 👈 New loading state
//   const { LoginWithOTP } = useAuth({
//     middleware: 'guest',
//     redirectIfAuthenticated: '/account',
//   });
//   const {
//     register,
//     handleSubmit,
//     setError,
//     formState: { errors },
//   } = useForm<OTPFormInputs>();

//   const onSubmit = async (data: OTPFormInputs) => {
//     setLoading(true); // 👈 Start loading
//     try {
//       if (!otpSent) {
//         const res = await axios.post('/api/v2/send-login-otp', {
//           email: data.email,
//         });
//         if (res.data.result) {
//           setOtpSent(true);
//           setEmailStored(data.email);
//           toast.success(res.data.message || 'Send OTP in your phone');
//         } else {
//           toast.error(res.data.message || 'Something went wrong');
//         }
//       } else {
//         const payload = {
//           email: emailStored,
//           otp_code: data.otp_code,
//         };
//         await LoginWithOTP(payload);
//       }
//     } catch (error: any) {
//       if (error.response?.status === 422) {
//         const apiErrors = error.response.data.errors;
//         Object.entries(apiErrors).forEach(([field, messages]: any) => {
//           setError(field as keyof OTPFormInputs, {
//             type: 'manual',
//             message: messages[0],
//           });
//         });
//       } else {
//         console.error('Unexpected error:', error);
//       }
//     } finally {
//       setLoading(false); // 👈 End loading
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit(onSubmit)}>
//       <div className="row g-3">
//         {!otpSent && (
//           <div className="col-12">
//             <label htmlFor="email" className="form-label">
//               Phone
//             </label>
//             <input
//               type="text"
//               className={`form-control ${errors.email ? 'is-invalid' : ''}`}
//               id="email"
//               placeholder="Enter your phone number"
//               {...register('email', { required: 'Phone number is required' })}
//               disabled={loading} // 👈 Disable while loading
//             />
//             {errors.email && (
//               <div className="invalid-feedback">{errors.email.message}</div>
//             )}
//           </div>
//         )}

//         {otpSent && (
//           <div className="col-12">
//             <label htmlFor="otp_code" className="form-label">
//               OTP Code
//             </label>
//             <input
//               type="text"
//               className={`form-control ${errors.otp_code ? 'is-invalid' : ''}`}
//               id="otp_code"
//               placeholder="Enter OTP"
//               {...register('otp_code', { required: 'OTP is required' })}
//               disabled={loading} // 👈 Disable while loading
//             />
//             <div className="w-full d-flex justify-content-end gap-2">
//               <span>120 s</span>{' '}
//               <span
//                 style={{ cursor: 'pointer' }}
//                 className="text-danger pointer"
//               >
//                 Resend OTP
//               </span>
//             </div>
//             {errors.otp_code && (
//               <div className="invalid-feedback">{errors.otp_code.message}</div>
//             )}
//           </div>
//         )}

//         <div className="col-12">
//           <button
//             type="submit"
//             className="trk-btn trk-btn--secondary d-block"
//             disabled={loading} // 👈 Disable button while loading
//           >
//             {loading
//               ? 'Please wait...' // 👈 Loading indicator
//               : otpSent
//                 ? 'Verify OTP'
//                 : 'Send OTP'}
//           </button>
//         </div>
//       </div>
//     </form>
//   );
// };

// export default LoginWithOTP;

'use client';

import axios from '@/lib/axios';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../hooks/auth';
import { toast } from 'react-toastify';

interface OTPFormInputs {
  email: string;
  otp_code?: string;
}

const LoginWithOTP = ({ redirect }: any) => {
  const [otpSent, setOtpSent] = useState(false);
  const [emailStored, setEmailStored] = useState('');
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const { LoginWithOTP } = useAuth({
    middleware: 'guest',
    redirectIfAuthenticated: redirect || '/account',
    goBack: true,
  });
  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<OTPFormInputs>();

  // Countdown timer effect
  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [countdown]);

  const sendOTP = async (email: string) => {
    setLoading(true);
    try {
      const res = await axios.post('/api/v2/send-login-otp', {
        email: email,
      });
      if (res.data.result) {
        setOtpSent(true);
        setEmailStored(email);
        setCountdown(120); // Start 120-second countdown
        toast.success(res.data.message || 'OTP sent to your phone');
      } else {
        toast.error(res.data.message || 'Something went wrong');
      }
    } catch (error: any) {
      if (error.response?.status === 422) {
        const apiErrors = error.response.data.errors;
        Object.entries(apiErrors).forEach(([field, messages]: any) => {
          setError(field as keyof OTPFormInputs, {
            type: 'manual',
            message: messages[0],
          });
        });
      } else {
        console.error('Unexpected error:', error);
        toast.error('Failed to send OTP. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResendOTP = async () => {
    if (countdown > 0) return;
    await sendOTP(emailStored);
  };

  const onSubmit = async (data: OTPFormInputs) => {
    setLoading(true);
    try {
      if (!otpSent) {
        await sendOTP(data.email);
      } else {
        const payload = {
          email: emailStored,
          otp_code: data.otp_code,
        };
        await LoginWithOTP(payload);
      }
    } catch (error: any) {
      if (error.response?.status === 422) {
        const apiErrors = error.response.data.errors;
        Object.entries(apiErrors).forEach(([field, messages]: any) => {
          setError(field as keyof OTPFormInputs, {
            type: 'manual',
            message: messages[0],
          });
        });
      } else {
        console.error('Unexpected error:', error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row g-3">
        {!otpSent && (
          <div className="col-12">
            <label htmlFor="email" className="form-label">
              Phone
            </label>
            <input
              type="text"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              id="email"
              placeholder="Enter your phone number"
              {...register('email', { required: 'Phone number is required' })}
              disabled={loading}
            />
            {errors.email && (
              <div className="invalid-feedback">{errors.email.message}</div>
            )}
          </div>
        )}

        {otpSent && (
          <div className="col-12">
            <label htmlFor="otp_code" className="form-label">
              OTP Code
            </label>
            <input
              type="text"
              className={`form-control ${errors.otp_code ? 'is-invalid' : ''}`}
              id="otp_code"
              placeholder="Enter OTP"
              {...register('otp_code', { required: 'OTP is required' })}
              disabled={loading}
            />
            <div className="w-full d-flex justify-content-end gap-2">
              {countdown > 0 ? (
                <span>
                  You can Resend the code after{' '}
                  <span style={{ color: '#E5456D' }}>{countdown}</span> second
                </span>
              ) : (
                <span
                  style={{ cursor: 'pointer', color: '#E5456D' }}
                  onClick={handleResendOTP}
                >
                  Resend OTP
                </span>
              )}
            </div>
            {errors.otp_code && (
              <div className="invalid-feedback">{errors.otp_code.message}</div>
            )}
          </div>
        )}

        <div className="col-12">
          <button
            type="submit"
            className="trk-btn trk-btn--secondary d-block"
            disabled={loading}
          >
            {loading ? 'Please wait...' : otpSent ? 'Verify OTP' : 'Send OTP'}
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginWithOTP;
